import {
  Button,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./Login.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";
import ModaMobileLogin from "../../components/ModaMobileLogin/ModaMobileLogin";

const Login = () => {
  const { handleLogin, objUserTk } = useContext(AuthContext);
  const { getUsersById } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  const [login, setLogin] = useState<UserProps>({
    password: "",
    email: "",
  });

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await handleLogin(login);
    setLoading(false);
    const user = jwtDecode(localStorage.getItem("token") || "") as UserToken;

    await getUsersById(user.UserId);
  };

  const handleInputChange = (valueAtt: any, name: string) => {
    setLogin((prevLogin) => ({
      ...prevLogin,
      [name]: valueAtt,
    }));
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
      setIsMobileView(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {/* <ModaMobileLogin /> */}

      <Row className="justify-content-center login-container">
        <Col
          lg="8"
          md="6"
          className="d-flex login-content"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <img
            className="login-logo"
            alt="Logo"
            src={require("../../assets/img/brand/Simbolo_Negativa_sf.png")}
          />

          <div className="d-flex login-slogan" style={{ flexDirection: "column", gap: "4px" }}>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "5.76px",
                color: "#43474F",
                opacity: 1,
                fontSize: "24px",
              }}
            >
              O SignFlow facilita sua vida!
            </span>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "2.24px",
                color: "#43474F",
                opacity: 0.7,
                fontSize: "11px",
              }}
            >
              GESTÃO E ASSINATURA DE DOCUMENTOS DE MANEIRA FÁCIL E SEGURA
            </span>
          </div>

          <div className="login-form-wrapper">
            <form
              role="form"
              className="login-form"
            >
              <InputEmailLogin
                name="email"
                value={login.email}
                handleChange={handleInputChange}
                label={"E-mail"}
              />

              <InputPassword
                name="password"
                value={login.password}
                handleChange={handleInputChange}
                label={"Senha"}
              />
            </form>

            <span
              onClick={() => (window.location.href = "/auth/forgot-password")}
              className="login-forgot-link"
            >
              Esqueceu sua senha?
            </span>

            <div className="login-buttons">
              <Button
                onClick={handleLoginClick}
                className="button-login"
                type="button"
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <Person2OutlinedIcon />
                )}{" "}
                FAZER LOGIN
              </Button>
              {/* <Button
                onClick={() => (window.location.href = "/auth/register")}
                className="button-login button-login-secondary"
                type="button"
              >
                🚀 CADASTRE-SE CLICANDO AQUI
              </Button> */}
            </div>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Login;
